// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
import CheckboxField from '../../customFields/CheckboxField';

const AcceptTermsField = field => (
  <CheckboxField
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    {...field}
    meta={{
      ...field.meta,
      touched: field.meta.touched || field.meta.submitFailed,
    }}
  />
);

const TermsSection = () => (
  <div className="content">
    <div className="h-paddings-half">
      <div
        className="flex-box"
      >
        <div
          style={{
            padding: '10px',
          }}
        >
          <label className="check_btn" htmlFor="acceptTerms">
            <Field
              name="acceptTerms"
              component={AcceptTermsField}
              type="checkbox"
              inputClassName="regcheck"
              required
            />
            I have read and agreed to the
          </label>
          
          <span className="font12" >
            
            {' '}
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              href="https://wurqly.com/Wurqly_terms_conditions.pdf"
              target="_blank"
              style={{
                textDecorationLine: 'underline',
                color: '#e87b68',
              }}
            >
              Term of Service
            </a>
            {', '}
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              href="https://wurqly.com/Wurqly_privicy_policy.pdf"
              target="_blank"
              style={{
                textDecorationLine: 'underline',
                color: '#e87b68',
              }}
            >
              Customer Privacy Policy
            </a>
          </span>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <span>
            Must agree to terms & policies
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default TermsSection;
